import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SigningStore } from '../store';
import { tap } from 'rxjs';
import { ROUTE } from '@portal/data-access';

export const documentPreviewGuard: CanActivateFn = (next: ActivatedRouteSnapshot) => {
  const store = inject(SigningStore);
  const router = inject(Router);

  return store.isVerified$.pipe(
    tap(isVerified => {
      return isVerified ? true : router.navigate([next.queryParams['redirect'] ?? ROUTE.VERIFICATION.MAIN]);
    }),
  );
};
